import { useContext } from 'react';

import { PluginsUpdateModeContext } from '../pluginsUpdateModeContext';

export function usePluginsUpdateMode() {
  return useContext(PluginsUpdateModeContext);
}
